import { cn } from "@/lib/utils";
import { brandAssets } from "@/lib/brandAssets";
import { ALLIA_LOGO_CLEAN } from "@/lib/alliaLogoClean";

export function MpiresLogo({ height = 60, className, trim = false }) {
  // `trim=true` usa a versão recortada (sem margem branca) com fundo transparente.
  // Só a barra do topo do celular usa `trim`. O logo grande da sidebar do
  // computador e o do menu ☰ continuam com o original + multiply.
  const src = trim ? brandAssets.MPIRES_LOGO_TRIM : brandAssets.MPIRES_LOGO;
  const style = trim
    ? { height, width: "auto", objectFit: "contain" }
    : { height, width: "auto", objectFit: "contain", mixBlendMode: "multiply" };
  return (
    <img
      src={src}
      alt="MPires — Especialista em higiene profissional"
      style={style}
      className={cn("select-none", className)}
      draggable={false}
    />
  );
}

export function AlliaBadge({ dark = false, className, height = 13 }) {
  return (
    <div className={cn("flex items-center gap-1.5", className)}>
      <span className={cn("text-[9px] uppercase tracking-[0.12em] font-medium", dark ? "text-white/45" : "text-muted-foreground")}>
        Empresa associada
      </span>
      <img
        src={ALLIA_LOGO_CLEAN}
        alt="Allia"
        style={{ height }}
        className="rounded-[2px] select-none"
        draggable={false}
      />
    </div>
  );
}
